/**
 * ProductAuditListContainer
 * --
 */
import React from 'react';
import { useUserStack } from 'store';
// import ProductAuditListPresenter from './ProductAuditListPresenter';
import ProductAuditList from 'routes/admin.routes/admin.products/ProductAuditList';

const ProductAuditListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ProductAuditList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default ProductAuditListContainer;
